import React from 'react'
import withIcon from '@/components/withIcon'

function IconLightning({ className }) {
  return (
    <svg
      className={className}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4718 42.5309L21.2628 24.1868L13.6092 24.2848L22.3029 4.5099L33.5281 4.4707L23.7944 18.856L33.3712 18.8952L13.4718 42.5309Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="22.9256"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default withIcon(IconLightning)
